export const routes = [
  {
    path: "/",
    name: "main",
    redirect: {
      name: 'home'
    },
    component: resolve => require(["@/layout/main.vue"], resolve),
    children: [
      {
        path: "/",
        name: "home",
        component: resolve => require(["@/views/home/Home"], resolve),
        props: route => ({ targetId: route.query.t })
      }
    ]
  },
];
